import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CriarTurmaLayer from "../components/CriarTurmaLayer";
import { useTranslation } from "../i18n/I18nContext";

const CriarTurmaPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("turma.breadcrumb.create")} />
      <CriarTurmaLayer />
    </MasterLayout>
  );
};

export default CriarTurmaPage;
